import type {MilestonePickerMilestone} from '@github-ui/item-picker-milestone'
import {MilestonePicker} from '@github-ui/item-picker-milestone-tsq'
import type {SxProp} from '@primer/styled-react'

import {LABELS} from '../../constants/labels'
import {SectionHeader} from '../SectionHeader'
import {MilestonesSection, ReadonlyMilestonesSectionHeader} from './MilestonesSection'

export type CreateIssueMilestonesSectionProps = {
  repo: string
  owner: string
  milestone: MilestonePickerMilestone | null
  onSelectionChange: (milestone: MilestonePickerMilestone | null) => void
  viewerCanSetMilestone: boolean
  canCreateMilestone: boolean
  insidePortal: boolean
  className?: string
} & SxProp

export function CreateIssueMilestonesSection({
  milestone,
  onSelectionChange,
  viewerCanSetMilestone,
  canCreateMilestone,
  className,
  sx,
  ...sharedConfigProps
}: CreateIssueMilestonesSectionProps) {
  const sectionHeader = !viewerCanSetMilestone ? (
    <ReadonlyMilestonesSectionHeader />
  ) : (
    <MilestonePicker
      onSelectionChange={milestones => {
        onSelectionChange(milestones?.[0] || null)
      }}
      readonly={false}
      canCreateMilestone={canCreateMilestone}
      activeMilestone={milestone}
      anchorElement={(anchorProps, ref) => (
        <SectionHeader title={LABELS.sectionTitles.milestones} buttonProps={anchorProps} ref={ref} />
      )}
      showMilestoneDescription
      {...sharedConfigProps}
    />
  )

  return <MilestonesSection sx={sx} className={className} sectionHeader={sectionHeader} milestone={milestone} />
}
